<h1 class="page-title">
  <a routerLink="../.." class="nav-back"><i class="icon icon-arrow-left-9"></i></a> Research Portal Statistics
</h1>
<div class="container">
  <div class="row m-b">
    <div class="col-6 d-flex">
      <div class="card w-100">
        <app-research-portal-stats-daily-access-data (seriesClicked)="seriesClicked($event)"></app-research-portal-stats-daily-access-data>
      </div>
    </div>
    <div class="col-6  d-flex">
      <div class="card w-100">
        <app-research-portal-stats-total-access-data (seriesClicked)="seriesClicked($event)"></app-research-portal-stats-total-access-data>
      </div>
    </div>
  </div>
</div>
<app-research-portal-stats-audit-data [selectedActivityTypes]="selectedActivityTypes"></app-research-portal-stats-audit-data>
